var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nut-sidenavbar"},[_c('div',{staticClass:"sidenavbar-content"},[_c('div',{ref:"list",staticClass:"sidenavbar-list"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }